import React from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'

import Ladder from '../../static/images/icons/ladder.svg'

const Story = () => {
  AOS.init()
  AOS.refresh()

  return (
    <div className='section story'>
      <div className='background-intro'>
        <img src={Ladder} />
      </div>

      <div className='heading-inverse' data-aos='zoom-in' data-aos-delay='200'>
        Our Story
      </div>
      <p data-aos='zoom-in' data-aos-delay='200'>
        Rean Water is a unique water company which work on design-build-operate
        (DBO) model exclusively focused on executing water and wastewater
        projects in India. Their project portfolio execution includes
        design-engineering, procurement, water pipe laying and installation,
        protective coating services, building water treatment plant, last mile
        connectivity to households, refurbishment of infrastructure, undertaking
        other allied civil works involved in water projects, long term
        operations and maintenance. They specialised in project development
        located in rural areas in which household water connectivity are at the
        lowest. The company is led by a team with decades of experience in water
        projects and environmental solutions. It has a proven track record in
        completing multiple water projects for the government, most of which are
        backed by development agencies and multilateral institutions and have
        several outstanding projects in development within the portfolio. It has
        continued to deliver to stakeholders throughout the Covid-19 pandemic
        period.
      </p>
    </div>
  )
}

export default Story
